import React from "react";
import { stringifyHtmlClasses } from "utils/utils";

export const MinMaxThumb = ({ percentage, hovered, zIndex }) => (
  <span
    className={stringifyHtmlClasses({ thumb: true, hover: hovered })}
    style={{ left: `${percentage}%`, zIndex }}
  />
);
